module.exports = {
  customer: 'stirling',
  environment: 'production',
  yourMoney: true,
  jobsVolunteering: true,
  googleAnalyticsId: 'G-5SZ63WP5HM',
  robots: true,
  chatWidget: false,
  entitledToBaseUrl: 'https://stirlingbetteroff.entitledto.co.uk',
  entitledToReassessUrl: 'https://stirlingbetteroff.entitledto.co.uk/reassessbetteroff',
  requirePostcode: false,

  app: {
    home: 'https://stirling.betteroff.org.uk'
  },
  serverBaseUrl: 'https://api-stirling.betteroff.org.uk',
  api: {
    baseUrl: 'https://api-stirling.betteroff.org.uk/internal/v1'
  },
  authGateway: 'https://account.stirling.betteroff.org.uk',
  loginServices: [
    {name: 'kerp'},
    {name: 'phone'},
    {name: 'google', postLogoutUrl: 'https://accounts.google.com/Logout'},
    {name: 'facebook'},
    {name: 'agent'},
    {name: 'referenceNumber'}
  ],
  ui: {
    showJobSearchJournal: true,
    showOfflineForms: true,
    showAssessmentMutators: false,
    restrictions: {
      applications: false
    }
  },
  airbrake: {
    enabled: true,
    projectId: 131082,
    projectKey: 'facc9a060872b357453b677f15d319e3'
  }
};
